export default __webpack_public_path__ + "static/media/close.9cfc5ec8.svg";